import React from 'react';
import From from "./From";
import ContactInfo from "./ContactInfo";
import {sendMessage} from "../../services/messages";

const ContactPage = () => {
    return (
        <div className={'contact-page-area-wrapper sp-y'}>
            <div className="container">
                <div className="contact-content-wrap">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="contact-form-area contact-method">
                                <h3>Send us a Message</h3>
                                <From sendMessage={sendMessage} />
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="contact-information contact-method">
                                <div className="contact-info-con">
                                    <h3>Contact Info</h3>
                                    <ContactInfo
                                        address=" 2901 DRUID PARK DRIVE
                                <br/>Suite 303 A, B &amp; C<br/>
                                MD 21215, USA <br/>
                                TEL: 443-869-3660, 202-455-2220
                                FAX: 202-919-3040"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;